import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data',
  templateUrl: './data.component.html',
  styleUrls: ['./data.component.scss']
})
export class DataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  getUsers = "query GetUsers (ids: [\"abc\", \"bcd\"]) {id email name}";
  getUsersResponse = JSON.stringify([{
    "id": "0362a310-8dae-11e5-a437-71c8810d67c0",
    "name": "Vincent Roazzi Jr",
    "email": "vincent.roazzi.jr@gmail.com"
  }], null, "\t");

  getUser = "query GetUser (id: \"0362a310-8dae-11e5-a437-71c8810d67c0\") {instance{id email name roles wishList districts{id name}} constants}";
  getUserResponse = JSON.stringify({
    instance:{
      user: {
      "id": "0362a310-8dae-11e5-a437-71c8810d67c0",
      "name": "Vincent Roazzi Jr",
      "email": "vincent.roazzi.jr@gmail.com",
      "role":64
    },
      wishList: {
        "attractions": [
          {
            "name": "Alpine Organic Homestay ",
            "id": "c75e1190-cd65-11e5-9e8e-d93b53b9a53b",
            "type": "attractions"
          }
        ],
        "locations": [],
        "guides": [
          {
            "name": "Tshering Dendup",
            "id": "f3e8cb70-cc2e-11e5-b20a-5dbd8585380b",
            "type": "guides"
          }
        ]
      },
      districts: []
    },
    constants: {
      "roles": [
        {
          "label": "Admin",
          "value": 2
        },
        {
          "label": "Agency",
          "value": 4
        },
        {
          "label": "Guide",
          "value": 8
        }
      ]
    }


  }, null, "\t");

  updateUser = "mutation UpdateUser($id: \"0362a310-8dae-11e5-a437-71c8810d67c0\", $email: \"vincent.roazzi.jr@gmail.com\",$role: \"64\", $name: \"Vincent Roazzi Jr\") {id}";

  getFaqs = "query GetFaqs (ids: [\"abc\", \"bcd\"]) {id title published, priority, tags{id name} }";
  getFaqsResponse = JSON.stringify([
    {
      "id": "f00c2980-0963-11e6-ae2c-1fa9f2dd5885",
      "title": "What is included with the government-mandated daily rate?",
      "published": true,
      "priority": 970,
      "tags": [
        {
          "id": "773a1c00-0941-11e6-ae2c-1fa9f2dd5885",
          "name": "Daily Fee"
        },
        {
          "id": "7d760d40-b18a-11e5-8da3-dfbe9fa91736",
          "name": "Daily Tariff"
        },
        {
          "id": "a5e217a0-b186-11e5-8da3-dfbe9fa91736",
          "name": "Payment"
        }
      ]
    }
  ], null, "\t");

  getFaq = "query GetFaq (id: \"0362a310-8dae-11e5-a437-71c8810d67c0\") {instance{id title slug body published notes priority tags{id name}}}";
  getFaqResponse = JSON.stringify({
    instance: {
      "id": "97ff2ae0-01a6-11e6-a5cf-f9a6ca292a03",
      "title": "What is the official language of Bhutan?",
      "slug": "what-is-the-official-language-of-bhutan",
      "body": "",
      "published": false,
      "notes": "",
      "priority": null,
      "tags": [
        {
          "id": "123456789abc",
          "name": "Good tag"
        }
      ]
    }
  }, null, "\t");

  updateFaq = "mutation UpdateFaq($id: \"0362a310-8dae-11e5-a437-71c8810d67c0\", $title: \"What is the official language of Bhutan?\",$slug: \"what-is-the-official-language-of-bhutan4\", $body: \"\", $published: \"false\", $tags: {ids: [\"1234abc\"]}) {id}";
  deleteFaq = "mutation DeleteFaq(id: \"0362a310-8dae-11e5-a437-71c8810d67c0\") {id}";

  getTags = "query GetFaqs (ids: [\"abc\"]) {id name faqsCount }";
  getTagsResponse = JSON.stringify([
    {
      "id": "a892c670-b18b-11e5-9ef1-791daa24554d",
      "name": "Domestic",
      "faqsCount": 3
    }
  ], null, "\t");

  getTag = "query GetTag (id: \"0362a310-8dae-11e5-a437-71c8810d67c0\") {instance{id name slug faqs{id title}}}";
  getTagResponse = JSON.stringify(
    {
      instance: {
        "id": "a892c670-b18b-11e5-9ef1-791daa24554d",
        "name": "Domestic",
        "slug": "domestic",
        "faqs": [
          {
            "id": "abc0123",
            "title": "What is the official language of Bhutan?"
          }
        ]
      }
    }, null, "\t");

  updateTag = "mutation UpdateTag($id: \"0362a310-8dae-11e5-a437-71c8810d67c0\", $name: \"Domestic\",$slug: \"domestic\") {id}";
  deleteTag = "mutation DeleteTag(id: \"0362a310-8dae-11e5-a437-71c8810d67c0\") {id}";


  getLocations = "query GetLocations (ids: [\"abc\"]) {id name childrenCount }";
  getLocationsResponse = JSON.stringify([
    {
      "id": "82e084a0-9271-11e5-b9b0-7d2cb5736d20",
      "name": "Athang",
      "childrenCount": 3
    }
  ],null, "\t");

  getLocation = "query GetLocation (id: \"0362a310-8dae-11e5-a437-71c8810d67c0\") {instance{id name dzongkha slug description body notes featuredFileId files{id name mimetype url description notes caption credit editor} children{id name childrenCount}} locations{id name}}";
  getLocationResponse = JSON.stringify({
    "instance": {
      "id": "68611b80-9258-11e5-a890-ad088a91b1f3",
      "name": "Mongar",
      "dzongkha": "མོང་གར།",
      "slug": "mongar",
      "description": null,
      "body": false,
      "notes": null,
      "featuredFileId": "a693c230-d084-11e5-8240-f1715739639f",
      "files": [
        {
          "id": "a693c230-d084-11e5-8240-f1715739639f",
          "name": null,
          "mimetype": "image/jpeg",
          "url": "https://mybhutan.imgix.com/a693c230-d084-11e5-8240-f1715739639f.jpg",
          "description": null,
          "notes": null,
          "caption": null,
          "credit": "MyBhutan's Vincent Roazzi Jr.",
          "editor": null
        }
      ],
      "children": [
        {
          "id": "f62fe520-926e-11e5-9298-dd536f8cf3ee",
          "name": "Balam",
          "childrenCount": 0
        }
      ]
    },
    "locations": [
      {
        "id": "82e084a0-9271-11e5-b9b0-7d2cb5736d20",
        "name": "Athang"
      }
    ]
  },null, "\t");

  updateLocation = "mutation UpdateLocation($id: \"0362a310-8dae-11e5-a437-71c8810d67c0\", $name: \"Mongar\",$slug: \"mongar\", $dzongkha: \"abcd\" , $description: \"\" , $body: \"\" , $notes: \"\" , $featuredFileId: \"\", $files: [], $children: []) {id}";
  deleteLocation = "mutation DeleteLocation(id: \"0362a310-8dae-11e5-a437-71c8810d67c0\") {id}";

  getAttractions = "query GetAttractions (ids: [\"abc\"]) {id name type location{id name} filesCount}";
  getAttractionsResponse = JSON.stringify([
    {
      "id": "73a74470-d06e-11e5-81fe-b50c13f4d94b",
      "name": "4x4 Off Road",
      "type": "activity",
      "location": {
        "id": "73361650-9258-11e5-a890-ad088a91b1f3",
        "name": "Thimphu"
      },
      "filesCount": 3
    }
  ], null, "\t");

  getAttraction = "query GetAttraction (id: \"0362a310-8dae-11e5-a437-71c8810d67c0\") {instance{" +
    "id name type alternateName slug description internalNotes " +
    "author editor ownerName phoneNumber emailAddress address " +
    "website rating type published propertyRelease distance duration " +
    "altitude difficulty craftType flow bestSeason accommodationType activityType " +
    "amenities yearOfEstablishment numberOfRooms numberOfBeds roomTypes " +
    "hoursOfOperation additionalCost additionalCosts{label amount description perPerson} " +
    "cuisines raftingClass locationId featuredFileId gallery{id url} " +
    "files{id url mimetype caption credit editor attractionId locationId guideId} " +
    "} locations{id name}} constants";
  getAttractionResponse = JSON.stringify({
    "instance": {
      "id": "854483d0-c26a-11e5-a88e-6d94aeb03982",
      "name": "Tiger's Nest",
      "alternateName": "Taktsang, Taktshang",
      "slug": "tigers-nest",
      "description": "From a distance, Bhutan..",
      "internalNotes": null,
      "author": "Joanna James",
      "editor": "Harrison Rappaport",
      "ownerName": null,
      "phoneNumber": null,
      "emailAddress": null,
      "address": null,
      "website": null,
      "rating": null,
      "type": "attraction",
      "published": true,
      "propertyRelease": null,
      "distance": null,
      "duration": null,
      "altitude": null,
      "difficulty": "novice",
      "craftType": null,
      "flow": null,
      "bestSeason": [],
      "accommodationType": null,
      "activityType": null,
      "amenities": [],
      "yearOfEstablishment": null,
      "numberOfRooms": null,
      "numberOfBeds": null,
      "roomTypes": null,
      "hoursOfOperation": null,
      "additionalCost": null,
      "additionalCosts": [
        {
          "label": "Horseback Ride",
          "amount": "15",
          "description": "The horseback ride ends at Taktsang Cafeteria",
          "perPerson": true
        }
      ],
      "cuisines": [],
      "raftingClass": null,
      "locationId": "637b5380-926f-11e5-9cb2-93912710d494",
      "featuredFileId": "49196b42-c26b-11e5-a88e-6d94aeb03982",
      "gallery": [
        {
          "id": "72dcf710-d154-11e5-86a9-c79f26378559",
          "path": "f1ddce98-c776-4829-bf8e-fd6227b61efe"
        }
      ],
      "files": [
        {
          "id": "49191d20-c26b-11e5-a88e-6d94aeb03982",
          "url": "https://mubhutan.imgix.com/e99678a3-5fc1-4d75-9a98-eacf80a92306.jpg",
          "mimetype": "image/jpeg",
          "caption": null,
          "credit": "Glen Thomson for MyBhutan",
          "editor": null,
          "attractionId": "854483d0-c26a-11e5-a88e-6d94aeb03982",
          "locationId": "637b5380-926f-11e5-9cb2-93912710d494",
          "guideId": null
        }
      ]
    },
    "locations": [
      {
        "id": "82e084a0-9271-11e5-b9b0-7d2cb5736d20",
        "name": "Athang"
      }
    ],
    "constants": {
      "difficulties": [
        {
          "name": "Novice",
          "key": "novice"
        },
        {
          "name": "Intermediate",
          "key": "intermediate"
        },
        {
          "name": "Expert",
          "key": "expert"
        }
      ]
    }
  }, null, "\t");

  updateAttraction = "mutation UpdateAttraction($id: \"0362a310-8dae-11e5-a437-71c8810d67c0\", " +
    "$name: \"\", $type: \"\", $alternateName: \"\", $slug: \"\", $description: \"\", $internalNotes: \"\", " +
    "$author: \"\", $editor: \"\", $ownerName: \"\", $phoneNumber: \"\", $emailAddress: \"\", $address: \"\", " +
    "$website: \"\", $rating: \"\", $type: \"\", $published: \"\", $propertyRelease: \"\", $distance: \"\", $duration: \"\", " +
    "$altitude: \"\", $difficulty: \"\", $craftType: \"\", $flow: \"\", $bestSeason: \"\", $accommodationType: \"\", $activityType: \"\", " +
    "$amenities: [], $yearOfEstablishment: \"\", $numberOfRooms: \"\", $numberOfBeds: \"\", $roomTypes: \"\", " +
    "$hoursOfOperation: \"\", $additionalCost: \"\", $additionalCosts{label amount description perPerson}, " +
    "$cuisines: \"\", $raftingClass: \"\", $locationId: \"\", $featuredFileId: \"\", $gallery: [], " +
    "$files: [] ";
  deleteAttraction = "mutation DeleteAttraction(id: \"0362a310-8dae-11e5-a437-71c8810d67c0\") {id}";

  getAgencies = "query GetAgencies (ids: [\"b8944640-1907-11e7-9a74-29b98a9dd059\"]) {id name locked guidesCount}";
  getAgenciesResponse = JSON.stringify({"id":"b8944640-1907-11e7-9a74-29b98a9dd059","name":"Abhaya Bhutan Tours and Treks","locked":null,"guidesCount":5}, null, "\t");

  getAgency = "query GetAgency (id: \"0362a310-8dae-11e5-a437-71c8810d67c0\") {instance{id name logo slug shortDescription description officeHours established licenseHolder address phoneNumber fax email website live approved verified locked logoFileId guides{name id headshot{url}}} guides{name id headshot{url}}}";
  getAgencyResponse = JSON.stringify({
    "instance": {
      "id": "4236d0b0-8daf-11e5-ae1e-057c174e5326",
      "name": "Authentic Bhutan Tours",
      "slug": "authentic-bhutan-tours",
      "shortDescription": "Short description",
      "description": "<p style=\"text-align: center;\">Short description</p>",
      "officeHours": null,
      "established": null,
      "licenseHolder": null,
      "address": "Box Office 90210",
      "phoneNumber": "+1234567890",
      "fax": "+1234567890",
      "email": "authenticbhutan@druknet.bt",
      "website": "www.authenticbhutan.com.bt",
      "live": false,
      "approved": false,
      "verified": false,
      "locked": true,
      "logoFileId": null,
      "logo": "http://via.placeholder.com/80x80",
      "guides": [
        {
          "id": "8a729dd0-ca06-11e5-8041-fdc474b93f3f",
          "name": "Chencho Tshering",
          "headshot": {
            "id": "d9e8df00-ca06-11e5-8b6b-011eb304002e",
            "url": "https://mybhutan.imgix.com/4ae67936-55f2-4267-94d5-f88b93d8304c.jpg",
            "mimetype": "image/jpeg"
          }
        }
      ]
    },
    "guides": [
      {
        "name": "Tshering Dendup",
        "id": "f3e8cb70-cc2e-11e5-b20a-5dbd8585380b",
        "headshot": {
          "url": "https://mybhutan.imgix.com/a44e845c-0f2a-4618-85a6-1a13e69520ae.jpg"
        }
      }
    ]
  }, null, "\t");

  updateAgency = "mutation UpdateAgency($id: \"0362a310-8dae-11e5-a437-71c8810d67c0\", $name: \"\", $slug: \"\", $description: \"\", $officeHours: \"\", $established: \"\", $licenseHolder: \"\", $address: \"\", $phoneNumber: \"\", $fax: \"\", $email: \"\", $website: \"\", $live: \"\", $approved: \"\", $verified: \"\", $guides: \"\") {id}";
  deleteAgency = "mutation DeleteAgency(id: \"0362a310-8dae-11e5-a437-71c8810d67c0\") {id}";

  getGuides = "query GetGuides (ids: [\"b8944640-1907-11e7-9a74-29b98a9dd059\"]) {id name type licenseNumber headshotFileId languagesCount}";
  getGuidesResponse = JSON.stringify([
    {
      "id": "8be4e270-c909-11e5-8c48-1bbcda6a11e3",
      "name": "Arun Kumar Rai",
      "type": "permanent",
      "licenseNumber": "0061/06",
      "headshotFileId": "c7aed2c0-c909-11e5-964e-8778daae973b",
      "languagesCount": 5
    }
  ], null, "\t");

  getGuide =
  "query GetGuide (id: \"8be4e270-c909-11e5-8c48-1bbcda6a11e3\"){"+
  " instance{"+
  "     id name slug published cid licenseNumber dob mailingAddress phoneNumber emailAddress type tcbCertified gender modelRelease additionalFee education"+
  "     university yearOfGraduation major driversLicense training strengths hobbiesString favoriteSites why uniqueness favoriteThing bestExperience touristDescription"+
  "     specialAboutBhutan whyVisitBhutan challenges whyIGuide supportiveOrganizations groupsPerYear specializations trekking cooking locationId headshotFileId"+
  "     files{"+
  "       id mimetype url description notes caption credit editor locationId attractionId guideId"+
  "     }"+
  "     languages{id name}"+
  "     districts{id name}"+
  "     tags{id name}"+
  "     agencies{id name}"+
  "   }"+
  "   languages{id name}"+
  "   locations{id name}"+
  "   districts{id name}"+
  "   agencies{id name}"+
  "   tags{id name}"+
  "   constants"+
  " }";


  getGuideResponse = JSON.stringify({
    "instance": {
      "id": "8be4e270-c909-11e5-8c48-1bbcda6a11e3",
      "name": "Arun Kumar Rai",
      "slug": "arun-kumar-rai",
      "published": true,
      "cid": "10205003590",
      "licenseNumber": "0061/06",
      "dob": "08/14/1985",
      "mailingAddress": "Etho Meto Tours",
      "phoneNumber": "17642334",
      "emailAddress": "btarunrai@gmail.com",
      "type": "permanent",
      "tcbCertified": true,
      "gender": "male",
      "modelRelease": true,
      "additionalFee": null,
      "education": "class-xii",
      "university": null,
      "yearOfGraduation": null,
      "major": null,
      "driversLicense": true,
      "training": "Iconography, Driglam Namzha, Gross National Happiness, and first aid.",
      "strengths": "Patience and knowledge.",
      "hobbiesString": "Playing football, listening to music, meeting and talking with people.",
      "favoriteSites": "Gangtey nature walk.",
      "why": "I am a unique tour guide.",
      "uniqueness": "I am jolly and funny.",
      "favoriteThing": "Bhutan is peaceful in general.",
      "bestExperience": null,
      "touristDescription": "Professional guide.",
      "specialAboutBhutan": "Bhutan is a culture base.",
      "whyVisitBhutan": "Bhutan is different from the outside world.",
      "challenges": null,
      "whyIGuide": "interaction with different people",
      "supportiveOrganizations": "Guide Association of Bhutan",
      "groupsPerYear": 16,
      "specializations": [
        "birding",
        "flora",
        "fauna",
        "bicycling"
      ],
      "trekking": [
        "drukpath",
        "bumthang"
      ],
      "cooking": "good",
      "locationId": "78040a70-cc32-11e5-b20a-5dbd8585380b",
      "headshotFileId": "c7aed2c0-c909-11e5-964e-8778daae973b",
      "files": [
        {
          "id": "35b4b2a0-cc9b-11e5-a7a5-13722481026e",
          "mimetype": "video/mp4",
          "url": "https://mybhutan.imgix.com/71735e95-7ebb-4449-90df-0c38c4014f53.mpeg",
          "description": null,
          "notes": null,
          "caption": null,
          "credit": null,
          "editor": null,
          "locationId": null,
          "attractionId": null,
          "guideId": "8be4e270-c909-11e5-8c48-1bbcda6a11e3"
        }
      ],
      "languages": [
        {
          "id": "6a3d4020-c96f-11e5-8041-fdc474b93f3f",
          "name": "English"
        }
      ],
      "tags": [],
      "districts": [],
      "agencies": []
    },
    "locations": [
      {
        "id": "82e084a0-9271-11e5-b9b0-7d2cb5736d20",
        "name": "Athang"
      }
    ],
    "districts": [
      {
        "id": "64790be0-9258-11e5-a890-ad088a91b1f3",
        "name": "Bumthang"
      }
    ],
    "agencies": [
      {
        "id": "39bfc310-8daf-11e5-ae1e-057c174e5326",
        "name": "4B Tour and Treks"
      }
    ],
    "tags": [
      {
        "id": "d5d4dfd0-bfb2-11e5-820a-954596796d21",
        "name": "Landscape"
      }
    ],
    "constants": {
      "types": [
        {
          "name": "Freelance",
          "key": "freelance"
        },
        {
          "name": "Permanent",
          "key": "permanent"
        }
      ],
    }
  }, null, "\t");

  updateGuide = "mutation UpdateGuide ($id: \"\",$name: \"\",$slug: \"\",$published: \"\",$cid: \"\",$licenseNumber: \"\",$dob: \"\",$mailingAddress: \"\",$phoneNumber: \"\",$emailAddress: \"\",$type: \"\",$tcbCertified: \"\",$gender: \"\",$modelRelease: \"\",$additionalFee: \"\",$education: \"\",$university: \"\",$yearOfGraduation: \"\",$major: \"\",$driversLicense: \"\",$training: \"\",$strengths: \"\",$hobbiesString: \"\",$favoriteSites: \"\",$why: \"\",$uniqueness: \"\",$favoriteThing: \"\",$bestExperience: \"\",$touristDescription: \"\",$specialAboutBhutan: \"\",$whyVisitBhutan: \"\",$challenges: \"\",$whyIGuide: \"\",$supportiveOrganizations: \"\",$groupsPerYear: \"\",$specializations: \"\",$trekking: \"\",$cooking: \"\",$locationId: \"\",$headshotFileId: \"\",$files: []: \"\",$languages: []: \"\",$districts: []: \"\",$tags: []: \"\",$agencies: []){id}";
  deleteGuide = "mutation DeleteGuide(id: \"0362a310-8dae-11e5-a437-71c8810d67c0\") {id}";

  getLanguages = "query GetLanguages (ids: [\"b8944640-1907-11e7-9a74-29b98a9dd059\"]) {id name}";
  getLanguagesResponse = JSON.stringify([
    {
      "id": "e4afa370-dae5-11e5-93b6-47df55bcf016",
      "name": "Bengali"
    }
  ], null, "\t");

  getLanguage = "query GetLanguage (id: \"b8944640-1907-11e7-9a74-29b98a9dd059\") {id name slug}";
  getLanguageResponse = JSON.stringify({
    "id": "e4afa370-dae5-11e5-93b6-47df55bcf016",
    "name": "Bengali",
    "slug": "bengali"
  }, null, "\t");

  updateLanguage = "mutation UpdateLanguage ($id:\"\", $name: \"\", $slug: \"\")";
  deleteLanguage = "mutation DeleteLanguage(id: \"0362a310-8dae-11e5-a437-71c8810d67c0\") {id}";

  getDocs = "query GetDocs (ids: [\"b8944640-1907-11e7-9a74-29b98a9dd059\"]) {id name}";
  getDocsResponse = JSON.stringify([
    {
      "id": "4ad9a1c0-17f2-11e6-ac9f-9f9208b3f08d",
      "title": "Pricing"
    }
  ], null, "\t");

  getDoc = "query GetDoc (id: \"b8944640-1907-11e7-9a74-29b98a9dd059\") {id title body}";
  getDocResponse = JSON.stringify(
    {
      "id": "4ad9a1c0-17f2-11e6-ac9f-9f9208b3f08d",
      "title": "Pricing",
      "body": ""
    }  , null, "\t");

  updateDoc = "mutation UpdateDoc ($id:\"\", $title: \"\", $body: \"\")";
  deleteDoc = "mutation DeleteDoc(id: \"0362a310-8dae-11e5-a437-71c8810d67c0\") {id}";

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/data/data.component.ts